module.exports = __webpack_public_path__ + "img/story.f581d40c.png";